import { render, staticRenderFns } from "./TableDetailCard.vue?vue&type=template&id=36f8712a"
import script from "./TableDetailCard.vue?vue&type=script&lang=js"
export * from "./TableDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f8712a')) {
      api.createRecord('36f8712a', component.options)
    } else {
      api.reload('36f8712a', component.options)
    }
    module.hot.accept("./TableDetailCard.vue?vue&type=template&id=36f8712a", function () {
      api.rerender('36f8712a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/components/TableDetailCard.vue"
export default component.exports